import React, { useState } from 'react';
import Tools from '../../cvp-webgames-core/Misc/Tools';
import { Windows } from '../../pages/MainPage';
import { BaseConfig } from '../BaseConfig';
import GeneralButton from '../helpers/GeneralButton';
import { UIProperties } from '../UIProperties';
import ConfirmAlertUI from './ConfirmAlertUI';

import './HeaderUI.css'

const HeaderUI = (props: UIProperties<HeaderUIConfig>) => {
	const [showBackToMainMenu, setShowBackToMainMenu] = useState(false);

	return (
		<div>
			<div className="in-game-ui-container ui-hud-container modal-disable-select modal-disable-select">
				<img  style={{
					position: 'absolute'
				}} src="./assets/images/general/header/bar_header.png"/>
				
				<img style={{
					position: 'absolute',
					top: '3px',
					left: '12px',
					width: '245px'
				}} src="./assets/images/general/header/Medsurg_logo.png"/>

				<p id='first-object-main' tabIndex={0} aria-label={`Care score. ${props.parameters.score}`} className="care-score-font">CARE SCORE</p>

				<p className="score-font">{props.parameters.score}</p>

				<p className="score-pop score-animation" style={{
					position: 'absolute',
					margin: '0px',
					top: '5px',
					left: '170px',
					textAlign: 'center',
					width: '100%',
					fontSize: '28pt',
					opacity: '0',
					display: props.parameters.display,
				}}>{'+' + props.parameters.scorePop}</p>
				
				<GeneralButton parameters= {{
					ariaLbl: 'Exit Game',
					srcIdle: './assets/images/general/header/button_exit_main.png',
					srcHighlight: './assets/images/general/header/button_exit_down.png',
					top: '3px',
					right: '10px',
					width: '200px',
					highlightOnHover: true,
					onClicked: () => {
						props.parameters.onMainMenuClicked();
						setShowBackToMainMenu(true);
					}
				}}/>
			</div>
			<div>
			{showBackToMainMenu ? <ConfirmAlertUI id={Tools.generateGuid()} key={Tools.generateGuid()} dispatch={null} parameters= {{
                onYes: () => {
					
                    (props.parameters as any).updateWindow(Windows.MainMenu);
                },
                onNo: () => {
                    setShowBackToMainMenu(false);
                    props.parameters.onMainMenuPromptDismissed();
                },
                text: 'Are you sure you want to exit to the Game Envelope?',

			}}></ConfirmAlertUI>
			: (null)}
			</div>
		</div>
	);

};

export interface HeaderUIConfig extends BaseConfig {
	score: string;
	scorePop?: string;
	display?: string;
	//updateWindow: (windowToUse: Windows) => void;
	onMainMenuClicked: () => void;
	onMainMenuPromptDismissed: () => void;
	ignoreFinalName?: boolean;
}

export default HeaderUI;